/**
 * Hand evaluation. GAME_SPEC §1.
 *
 * Pure, no I/O. A single function with no variant deviation.
 */
/**
 * The "as written" point value of a rank, treating aces as 11. 2–10 face;
 * J/Q/K = 10; A = 11 (may be demoted to 1 by {@link getHandValue}).
 */
function rankBaseValue(rank) {
    switch (rank) {
        case 'A':
            return 11;
        case 'K':
        case 'Q':
        case 'J':
        case '10':
            return 10;
        default:
            return Number(rank); // '2'..'9'
    }
}
/**
 * Evaluate a hand. Sum all aces as 11, then demote aces to 1 one at a time
 * while the total exceeds 21. A hand is **soft** if it still contains an ace
 * counted as 11. GAME_SPEC §1.
 *
 * Pure; the input hand is never mutated. An empty hand evaluates to
 * `{ total: 0, isSoft: false }`.
 */
export function getHandValue(cards) {
    let total = 0;
    let aces = 0; // number of aces currently counted as 11
    for (const card of cards) {
        total += rankBaseValue(card.rank);
        if (card.rank === 'A')
            aces += 1;
    }
    // Demote aces from 11 to 1 (subtract 10 each) while busting and an ace remains.
    while (total > 21 && aces > 0) {
        total -= 10;
        aces -= 1;
    }
    return { total, isSoft: aces > 0 };
}
/** True if `value` is a bust (total > 21). */
export function isBust(value) {
    return value.total > 21;
}
/**
 * True if the hand is a **natural**: exactly two cards totaling 21. GAME_SPEC §6
 * (a two-card 21 outranks a 3+-card 21).
 */
export function isNatural(cards) {
    return cards.length === 2 && getHandValue(cards).total === 21;
}
/** Convenience constructor for a {@link Card}. */
export function card(rank, suit) {
    return { rank, suit };
}
//# sourceMappingURL=hand.js.map